import { render, staticRenderFns } from "./MAuditsForDashboard.vue?vue&type=template&id=1bd53f26&scoped=true&lang=pug&"
import script from "./MAuditsForDashboard.vue?vue&type=script&lang=ts&"
export * from "./MAuditsForDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd53f26",
  null
  
)

export default component.exports